import React from "react";
import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Speed is the whole game.",
    body: "A lead who waits 10 minutes is 5x less likely to convert. Our agent replies inside WhatsApp in seconds, every hour, every day, in every timezone.",
  },
  {
    n: "02",
    title: "Qualify before you call.",
    body: "Stop paying humans to chase tire-kickers. The agent asks industry-specific questions, reads the answers, and scores intent before it ever reaches your team.",
  },
  {
    n: "03",
    title: "Only talk to buyers.",
    body: "Hot leads get booked into your calendar. Warm ones get nurtured with adaptive follow-ups. Your reps spend their day on revenue, not triage.",
  },
];

export const Manifesto = () => (
  <section className="mx-auto max-w-6xl px-5 py-28 sm:py-32" data-testid="manifesto">
    <div className="mb-16 max-w-2xl">
      <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand">The thesis</span>
      <h2 className="mt-4 font-display text-4xl font-black tracking-tighter text-charcoal sm:text-5xl">
        Manual lead qualification is quietly killing your pipeline.
      </h2>
    </div>

    <div className="space-y-4">
      {chapters.map((c, i) => (
        <motion.div
          key={c.n}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, delay: i * 0.05 }}
          className="grid grid-cols-1 items-start gap-6 border-t border-silver-300/60 py-10 md:grid-cols-12"
        >
          <div className="md:col-span-3">
            <span className="font-display text-6xl font-black leading-none text-metallic sm:text-7xl">
              {c.n}
            </span>
          </div>
          <div className="md:col-span-9">
            <h3 className="font-display text-2xl font-bold tracking-tight text-charcoal sm:text-3xl">
              {c.title}
            </h3>
            <p className="mt-3 max-w-2xl text-base leading-relaxed text-silver-700 sm:text-lg">
              {c.body}
            </p>
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);

export default Manifesto;
